<div class="animate__animated animate__fadeInRight">
     <div class="container-fluid mt-2">
          <app-lista-razon></app-lista-razon>
     </div>
</div>